module.exports = __webpack_public_path__ + "img/changhong-534df6f0.png";